import { Sloping } from '@/assets';
import { memo } from 'react';
import { TestimonialsSliceDefaultPrimaryTestimonialsItem } from '../../../../../../prismicio-types';
import styles from './testimonialCard.module.scss';

interface TestimonialCardProps {
  testimonial: TestimonialsSliceDefaultPrimaryTestimonialsItem;
  isVisible: boolean;
}

const TestimonialCardComponent = ({
  testimonial,
  isVisible,
}: TestimonialCardProps) => {
  return (
    <div className={`${styles.card} ${isVisible ? styles.isVisible : ''}`}>
      <div className={styles.testimonial}>
        <p className={styles.text}>{testimonial.text}</p>
        <span className={styles.name}>{testimonial.client_name}</span>
      </div>
      <div className={styles.plate}>
        <div className={styles.plate_content}>
          <span className={styles.loan_amount}>
            {testimonial.loan_amount_received}
          </span>
          <span className={styles.plate_text}>{testimonial.plate_text}</span>
        </div>
        <Sloping />
      </div>
    </div>
  );
};

export const TestimonialCard = memo(TestimonialCardComponent);
